import React from "react";

const AxesHelper = ({ axisThickness }) => {
  const axisLength = 25; // Length of the axes

  return (
    <group>
      {/* X-axis (Red) */}
      <mesh position={[axisLength / 2, 0, 0]} rotation={[0, 0, Math.PI / 2]}>
        <cylinderGeometry args={[axisThickness, axisThickness, axisLength, 32]} />
        <meshBasicMaterial color="red" />
      </mesh>

      {/* Y-axis (Green) */}
      <mesh position={[0, axisLength / 2, 0]}>
        <cylinderGeometry args={[axisThickness, axisThickness, axisLength, 32, undefined, false]} />
        <meshBasicMaterial color="green" />
      </mesh>

      {/* Z-axis (Blue) */}
      <mesh position={[0, 0, axisLength / 2]} rotation={[Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[axisThickness, axisThickness, axisLength, 32]} />
        <meshBasicMaterial color="blue" />
      </mesh>
    </group>
  );
};
export default AxesHelper;